import qs from 'query-string';
import { deleteRequest, getRequest, patchRequest, postRequest } from 'services/requests';

const services = {
    createRubric: (body) => postRequest(`/rubrics`, body),
    listRubrics: (filter, orderBy, skip, top) => {
        const query = qs.stringify(
            { $filter: filter, $orderBy: orderBy, $skip: skip, $top: top },
            { skipNull: true, skipEmptyString: true }
        );
        return getRequest(`/rubrics${query && `?${query}`}`);
    },
    updateRubric: (id, body) => patchRequest(`/rubrics/${id}`, body),
    deleteRubric: (id) => deleteRequest(`/rubrics/${id}`),
};

export default services;
